module.exports = __webpack_public_path__ + "static/img/application12-3.1240d32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application12-3.jpg
// module id = mkg2
// module chunks = 0